<lib-content-block class="mb-3 d-block">
  <lib-open-consults></lib-open-consults>
</lib-content-block>

<lib-content-block class="mb-3 d-block">
  <lib-patients></lib-patients>
</lib-content-block>
